import type { FormFlowUI } from "FormFlowUITypes";

export async function handlePendingActionsAsync(formFlowUI: FormFlowUI): Promise<boolean> {
  if (formFlowUI.pendingActionHandlers.size === 0) {
    return true;
  }

  let result = true;
  for (const handler of formFlowUI.pendingActionHandlers) {
    const handlerResult = await handler.handlePendingActionsAsync();

    // If any handler returns false, set the result to false and break the loop
    if (!handlerResult) {
      result = false;
      break;
    }
  }

  return result;
}
